import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EuiMenuModule } from '../../components';
import { EuiButtonModule } from '../../components';

import { EuiSidebarMenuComponent } from './eui-sidebar-menu.component';

const COMPONENTS = [
    EuiSidebarMenuComponent,
];

@NgModule({
    imports: [
        CommonModule, RouterModule,
        EuiMenuModule,
        EuiButtonModule,
    ],
    declarations: [
        ...COMPONENTS,
    ],
    exports: [
        ...COMPONENTS,
    ],
})
export class EuiSidebarMenuModule { }
